import React, { useState } from "react";
import "../ContactUs/ContactUs.css";
import { Link } from "react-router-dom";
import { MdEmail, MdPhone } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import { FaLinkedinIn,FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import Header from '../Header/Header';
import Footer from '../Footer/Footer';
// import axios from "axios";

function ContactUs() {
  const [first_name, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [first_nameError, setFirstNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [messageError, setMessageError] = useState("");

  const EmailReg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

  const handleSubmit = (e) => {
    if (onContact()) {
      alert("we will connect soon..");
      console.log(first_name);
      console.log(email);
      console.log(phone);
      console.log(message);
      // var Base_URL = " ";
      // var Data = {
      //   first_name: first_name,
      //   email: email,
      //   phone: phone,
      //   message: message,
      // };
      // var headerConfig = {
      //   headers: {
      //     accept: "application/json",
      //   },
      // };
      // axios
      //   .post(Base_URL + "/contact", Data, headerConfig)
      //   .then((response) => {
      //     if (response.status === 200) {
      //       console.log(first_name);
      //       console.log(email);
      //       console.log(phone);
      //       console.log(message);
      //     }
      //   })
      //   .catch(function (err) {
      //     alert("something wrong try again later");
      //     console.log(err.response.data.error.message);
      //   });
    }
  };
  const onContact = () => {
    let isValid = true;
    if (first_name === "") {
      isValid = false;
      setFirstNameError("First Name is empty");
      // alert("First Name is empty");
    }
    if (!EmailReg.test(email)) {
      isValid = false;
      setEmailError("Please enter valid email");
      if (email === "") {
        isValid = false;
        setEmailError("Email is empty");
      }
    }
    if (phone === "") {
      isValid = false;
      setPhoneError("Phone is empty");
    }
    if (message === "") {
      isValid = false;
      setMessageError("Message is empty");
    }
    return isValid;
  };
  return (
    <>
    <Header/>
      <div className="contact">
        <h1>
          ContactUs
          <hr />
        </h1>
        {/* <p>Get in touch with us to discuss your requirements!</p> */}

        <div className="contact-container">
          <div className="contact-container-div1">
            <div className="contact-card">
              <div>
                <MdEmail className="contact-container-icon" />
              </div>
              <div>
                <h3>Email</h3>
                <p>medisol@asianitg.com</p>
              </div>
            </div>
            <div className="contact-card">
              <div>
                <MdPhone className="contact-container-icon" />
              </div>
              <div>
                <h3>Phone Number</h3>
                <p>91-22-69074440</p>
              </div>
            </div>
            <div className="contact-card">
              <div>
                <IoLocationSharp className="contact-container-icon" />
              </div>
              <div>
                <h3>Head Office</h3>
                <p>
                  228, Pragati Industrial Estate, N. M. Joshi Marg, Lower Parel
                  (E) Mumbai, 400 011, India
                </p>
              </div>
            </div>
            <div className="contact-card">
              <div>
                <IoLocationSharp className="contact-container-icon" />
              </div>
              <div>
                <h3>Corporate Office</h3>
                <p>1417, Make Chamber V, Nariman Point, Mumbai 400 021</p>
              </div>
            </div>
            <div className="contact-card contact-card-social">
            <div className="footer-social contact-social">
              <Link to={"https://x.com/i/flow/login"} className="social-icons contact-social-icons">
                <FaXTwitter />
                {/* <img src={twitter} alt="gmail-icon"/> */}
              </Link>
              <Link
                to={"https://mail.google.com/mail"}
                className="social-icons contact-social-icons"
              >
                <MdEmail />
                {/* <img src={gmail} alt="gmail-icon"/> */}
              </Link>
              <Link
                to={
                  "https://www.linkedin.com/login?fromSignIn=true&trk=guest_homepage-basic_nav-header-signin"
                }
                className="social-icons contact-social-icons"
              >
                <FaLinkedinIn />
                {/* <img src={linkedin} alt="linkedin-icon"/> */}
              </Link>
              <Link
                to={"https://www.instagram.com/accounts/login/"}
                className="social-icons contact-social-icons"
              >
                <FaInstagram />
                {/* <img src={instagram} alt="linkedin-icon"/> */}
              </Link>
            </div>
            </div>
          </div>

          <div className="contact-container-div2">
            <div className="details">
              <h2 >Get in touch with us</h2>
              <p className="contact-details-title">We will connect soon..</p>
              <div className="detail">
                <p>Name</p>
                <input
                  type="text"
                  value={first_name}
                  onChange={(e) => [
                    setFirstName(e.target.value),
                    setFirstNameError(""),
                  ]}
                  placeholder="Enter Name"
                  required
                  className="contact-right-side-input"
                />
                <span className="contact_error">{first_nameError}</span>
              </div>
              <div className="detail">
                <p>Email</p>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => [
                    setEmail(e.target.value),
                    setEmailError(""),
                  ]}
                  placeholder="Enter Email"
                  required
                  className="contact-right-side-input"
                />
                <span className="contact_error">{emailError}</span>
              </div>
              <div className="detail">
                <p>Phone</p>
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => [
                    setPhone(e.target.value),
                    setPhoneError(""),
                  ]}
                  placeholder="Enter Phone Number"
                  required
                  className="contact-right-side-input"
                />
                <span className="contact_error">{phoneError}</span>
              </div>
              <div className="detail">
                <p>Message</p>
                <textarea
                  type="text"
                  value={message}
                  onChange={(e) => [
                    setMessage(e.target.value),
                    setMessageError(""),
                  ]}
                  placeholder="Enter Message"
                  required 
                  className="contact-message"  
                />
              </div>
              <span className="contact_error">{messageError}</span>

              <div className="bottom-container">
                <Link
                  // to="/contactus"
                  className="btn-send-message"
                  type="submit"
                  onClick={handleSubmit}>
                  Send Message
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </>
  );
}
export default ContactUs;
